@let config = (config$ | async)!;
<div class="layout-wrapper" [ngClass]="containerClass(config)" [class]="sidebarClass(config)">
  <div class="layout-content-wrapper">
    <div class="topBar">
      <div class="topBarDummy"></div>
      <app-topbar></app-topbar>
    </div>
    <div class="layout-main">
      <div class="layout-content" [ngClass]="{ expanded: isExpanded$ | async }">
        @defer {
          <router-outlet></router-outlet>
        }
      </div>
    </div>

    <!--        <app-footer></app-footer>-->
  </div>
  <app-rightmenu></app-rightmenu>
  <div class="layout-mask"></div>
</div>
